import {generateTokensFromArray} from '../__utils';
import type {BaseColors, ThemeColors, ThemeColorTokens} from './colors.types';

/**
 * When updating this array, also update:
 * packages/utilities/styled-tokens/themes/colors/colors.types.ts
 */
const themeColors: Array<keyof ThemeColors> = [
  'actionBlackGhostBackgroundHover',
  'actionBlackGhostBackgroundSelected',
  'actionPrimaryBackground',
  'actionPrimaryBackgroundHover',
  'actionPrimaryText',
  'actionPrimaryTextHover',
  'actionSecondaryBackground',
  'actionSecondaryBackgroundHover',
  'actionSecondaryBackgroundPressed',
  'actionSecondaryBorder',
  'actionSecondaryBorderHover',
  'actionSecondarySelectedBackground',
  'actionSecondarySelectedBackgroundPressed',
  'actionSecondaryText',
  'actionSecondaryTextHover',
  'actionWhiteGhostBackgroundHover',
  'actionWhiteGhostBackgroundSelected',
  'actionWhiteOutlineBackgroundSelected',
  'actionWhiteOutlineBorder',
  'actionWhiteOutlineBorderHover',
  'actionWhiteSolidBackgroundHover',
  'backgroundPrimary',
  'backgroundPrimaryDisabled',
  'backgroundSecondary',
  'backgroundTertiary',
  'backgroundRaised',
  'backgroundHighlight',
  'background1',
  'background2',
  'background3',
  'background4',
  'background5',
  'backgroundInactive',
  'backgroundInverse',
  'backgroundInverseHover',
  'blueBackground',
  'blueBackgroundDisabled',
  'blueBackgroundHover',
  'blueBackgroundPressed',
  'blueBorder',
  'blueCanvas',
  'blueCanvasTransparent',
  'blueChart',
  'blueChart2',
  'blueIcon',
  'blueOutline',
  'blueText',
  'blueTransparent',
  'blueTransparentHover',
  'brandIconDetail',
  'brandIconFocus',
  'brandIconOutline',
  'borderDefault',
  'borderTextInput',
  'borderCheckboxRadio',
  'border1',
  'border2',
  'border3',
  'border4',
  'chartSeriesTeal',
  'chartSeriesOrange',
  'chartSeriesLightPink',
  'chartSeriesGreen',
  'chartSeriesPink',
  'chartSeriesYellow',
  'chartSeriesBlue',
  'chartSeriesGray',
  'closeButtonBackground',
  'grayIcon',
  'grayTransparent',
  'grayBackground',
  'grayBackgroundHover',
  'grayBackgroundPressed',
  'grayBorder',
  'grayChart',
  'grayCanvas',
  'grayCanvasHover',
  'grayCanvasTransparent',
  'grayBackgroundTransparent',
  'grayBackgroundTransparentHover',
  'grayBackgroundDisabled',
  'greenBackground',
  'greenBackgroundDisabled',
  'greenBackgroundHover',
  'greenBackgroundPressed',
  'greenBorder',
  'greenCanvas',
  'greenCanvasTransparent',
  'greenChart',
  'greenIcon',
  'greenOutline',
  'greenText',
  'greenTransparent',
  'greenTransparentHover',
  'orangeBackground',
  'orangeBackgroundDisabled',
  'orangeBackgroundHover',
  'orangeBackgroundPressed',
  'orangeBorder',
  'orangeCanvas',
  'orangeCanvasTransparent',
  'orangeChart',
  'orangeIcon',
  'orangeText',
  'orangeTransparent',
  'orangeTransparentHover',
  'pinkBackground',
  'pinkBackgroundDisabled',
  'pinkBackgroundHover',
  'pinkBackgroundPressed',
  'pinkBorder',
  'pinkCanvas',
  'pinkCanvasTransparent',
  'pinkChart',
  'pinkIcon',
  'pinkOutline',
  'pinkText',
  'pinkTransparent',
  'pinkTransparentHover',
  'presenceDisabledBlue',
  'presenceDisabledGreen',
  'presenceDisabledOrange',
  'presenceDisabledPink',
  'presenceDisabledRed',
  'presenceDisabledYellow',
  'presenceCanvasBlue',
  'presenceCanvasGreen',
  'presenceCanvasOrange',
  'presenceCanvasPink',
  'presenceCanvasRed',
  'presenceCanvasYellow',
  'presenceOutlineBlue',
  'presenceOutlineGreen',
  'presenceOutlineOrange',
  'presenceOutlinePink',
  'presenceOutlineRed',
  'presenceOutlineYellow',
  'presencePrimaryBlue',
  'presencePrimaryGreen',
  'presencePrimaryOrange',
  'presencePrimaryPink',
  'presencePrimaryRed',
  'presencePrimaryYellow',
  'presenceSecondaryBlue',
  'presenceSecondaryGreen',
  'presenceSecondaryOrange',
  'presenceSecondaryPink',
  'presenceSecondaryRed',
  'presenceSecondaryYellow',
  'purpleBackground',
  'purpleBackgroundDisabled',
  'purpleBackgroundHover',
  'purpleBackgroundPressed',
  'purpleBorder',
  'purpleCanvas',
  'purpleCanvasTransparent',
  'purpleChart',
  'purpleChart2',
  'purpleIcon',
  'purpleOutline',
  'purpleText',
  'purpleTransparent',
  'purpleTransparentHover',
  'redBackground',
  'redBackgroundDisabled',
  'redBackgroundHover',
  'redBackgroundPressed',
  'redBorder',
  'redCanvas',
  'redCanvasTransparent',
  'redChart',
  'redIcon',
  'redOutline',
  'redText',
  'redTransparent',
  'redTransparentHover',
  'skeleton',
  'textBlackPrimary',
  'textBlackSecondary',
  'textDimmed',
  'textInverse',
  'textPrimary',
  'textSecondary',
  'textWhitePrimary',
  'textWhiteSecondary',
  'uiAutocompleteListBoxBackground',
  'uiAvatarColoredTextDisabled',
  'uiAvatarDefaultTextDisabled',
  'uiAvatarShadow',
  'uiBackgroundActive',
  'uiBackgroundHover',
  'uiBadgeBackground',
  'uiBadgeBackgroundHover',
  'uiBadgeBackgroundPressed',
  'uiBlackGhostBorder',
  'uiBlackGhostBorderHover',
  'uiBorderSolid',
  'uiCanvasBackground',
  'uiCardBackground',
  'uiCheckboxRadioBorderColor',
  'uiDragOverlayBackground',
  'uiInputBackground',
  'uiInputBorderColor',
  'uiInputBorderColorHover',
  'uiFuseControlFilter',
  'uiFuseControlHover',
  'uiFuseControlPressed',
  'uiMenuContentBackground',
  'uiMenuContentBackgroundLight',
  'uiMenuDivider',
  'uiModalBackdrop',
  'uiNumberInputButtonIconHoverColor',
  'uiNumberInputStepperBorder',
  'uiNumberInputStepperInputBorder',
  'uiNumberInputValueWrapperOutline',
  'uiNumberInputValueWrapperOutlineHover',
  'uiPopoverBackdrop',
  'uiScrollbarThumb',
  'uiScrollbarThumbHover',
  'uiSegmentedControlActive',
  'uiSelectBackground',
  'uiSelectBackgroundHover',
  'uiSelectBorder',
  'uiTableRowActiveBackground',
  'uiTableZebraStripeBackground',
  'yellowBackground',
  'yellowBackgroundDisabled',
  'yellowBackgroundHover',
  'yellowBackgroundPressed',
  'yellowBorder',
  'yellowCanvas',
  'yellowCanvasTransparent',
  'yellowChart',
  'yellowIcon',
  'yellowOutline',
  'yellowText',
  'yellowTransparent',
  'yellowTransparentHover',
];

const baseColors: Array<keyof BaseColors> = [
  'black',
  'blackA10',
  'blackA25',
  'blackA5',
  'blackA50',
  'blackA75',
  'white',
  'whiteA10',
  'whiteA25',
  'whiteA5',
  'whiteA50',
  'whiteA75',
];

export const themeColorTokens: ThemeColorTokens = {
  ...generateTokensFromArray(baseColors, {applyNamespace: true}),
  ...generateTokensFromArray(themeColors, {prefix: 'colors'}),
};
